import { gql } from '@apollo/client/core'
import { useQuery } from '@vue/apollo-composable'
import { IDetailsData, IDetailQuery } from '@types'

const FIND_NODE_DETAILS_QUERY = gql`
  query FindNodeNavigation($id: ID!) {
    findNodeNavigation(id: $id) {
      type
      payload {
        ... on NodeNavigationResponse {
          nodeNavigation {
            id
            id_parent
            title
            type
            children {
              id
              type
              title
            }
            details {
              ...DetailsFields
            }
          }
        }
      }
    }
  }

  fragment TaxationNodeFields on Taxation {
    title
    description
    external_nodes {
      id
      title
    }
    help_node {
      description
      external_nodes {
        title
        id
      }
    }
  }

  fragment TaxationFields on Taxation {
    ...TaxationNodeFields
    taxations {
      ...TaxationNodeFields
      taxations {
        ...TaxationNodeFields
        taxations {
          ...TaxationNodeFields
          taxations {
            ...TaxationNodeFields
            taxations {
              ...TaxationNodeFields
              taxations {
                ...TaxationNodeFields
                taxations {
                  ...TaxationNodeFields
                  taxations {
                    ...TaxationNodeFields
                    taxations {
                      ...TaxationNodeFields
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  fragment DetailsFields on NodeDetails {
    characteristics {
      description
      external_nodes {
        id
        title
      }
    }
    definition {
      description
      external_nodes {
        id
        title
      }
    }
    documentation {
      description
      external_nodes {
        id
        title
      }
    }
    nature {
      code
      purpose
      reference {
        id
        title
      }
    }
    regulations {
      id
      title
    }
    taxations {
      ...TaxationFields
    }
  }
`

export const useDetailsQuery = (variables: IDetailQuery) => {
  const query = useQuery<IDetailsData>(FIND_NODE_DETAILS_QUERY, variables, {
    fetchPolicy: 'cache-first'
  })
  return query
}
